<template>
  <div class="module-table">
    <el-table :data="paginatedData" border size="small" class="data-table">
      <el-table-column label="序号" width="80">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="名称">
        <template slot-scope="scope">
          {{ scope.row.senior_executive_name || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="职位">
        <template slot-scope="scope">
          {{ scope.row.senior_executive_position || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="简介">
        <template slot-scope="scope">
          {{ scope.row.senior_executive_brief || '-' }}
        </template>
      </el-table-column>

    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="moduleData.length"
      style="margin-top: 10px; text-align: right;"
    />
  </div>
</template>

<script>
export default {
  name: 'seniorExecutiveList',
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.moduleData.slice(start, start + this.pageSize);
    }
  },
  data() {
    return {
            currentPage: 1,
            pageSize: 10,
      title: '高管信息',
    }
  },
  props: {
    moduleData: {
      type: Array,
      default: () => []
    }
  },
  methods: {
        handleCurrentChange(val) {
            this.currentPage = val;
        },
  }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;

  .el-table {
    width: 100%;
  }
}
</style>